import {apiEndpoints, requestOptions} from './api/forecastersApi';
import {fetchWithAuth} from '@shared/utils/auth';

const ForecastersSystem = {
    namespaced: true,

    state: {
        countFavorites: 0,
        isLoading: false,
        mainData: [],
        forecasts: [],
        isAllForecaster: null,
        currentForecaster: null,
        isForecasterInfo: false,
        errors: [],
        accessDenied: false,
        linkNextPosts: ''
    },

    mutations: {
        // Количество избранных форкастеров
        incrementFavoritesCounter(state) {
            state.countFavorites++
        },
        decrementFavoritesCounter(state) {
            state.countFavorites--
        },

        // Обновление избранного форкастера в массиве форкастеров sidebar
        updateForecasterBookmark(state, {index, updatedForecaster}) {
            if (state.mainData.sidebar && Array.isArray(state.mainData.sidebar.forecasters)) {
                state.mainData.sidebar.forecasters.splice(index, 1, updatedForecaster);
            }
        },

        //Для получения форкастеров
        getForecastersStart(state) {
            state.isLoading = true;
            state.currentForecaster = null;
            // state.mainData = [];
            state.forecasts = [];
            state.errors = [];
            state.isAllForecaster = null;
            state.accessDenied = false;
            state.linkNextPosts = '';
        },
        getForecastersFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        getForecastersSuccess(state, {mainData, nextLink}) {
            state.isLoading = false;
            state.mainData = mainData;
            state.forecasts = mainData.forecasts;
            state.countFavorites = mainData.sidebar.total_bookmarks_forecasters
            state.isAllForecaster = true;
            state.isForecasterInfo = false;
            state.linkNextPosts = nextLink;
        },
        setAccessDenied(state, status) {
            state.accessDenied = status;
        },

        //Для добавления форкастера в избранное
        bookForecastersStart(state) {
            // state.isLoading = true;
            state.errors = [];
        },
        bookForecastersFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        bookForecastersSuccess(state) {
            state.isLoading = false;
            // state.forecasters = forecasters;
        },

        //Для удаления форкастера из избранного
        unbookForecastersStart(state) {
            // state.isLoading = true;
            state.errors = [];
        },
        unbookForecastersFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        unbookForecastersSuccess(state) {
            state.isLoading = false;
        },

        //Для получения форкастов одного форкастера
        getForecastsOfOneStart(state) {
            state.isLoading = true;
            state.forecasts = [];
            state.currentForecaster = null;
            state.errors = [];
            state.linkNextPosts = '';
            // state.isAllForecaster = null;
        },
        getForecastsOfOneFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        getForecastsOfOneSuccess(state, {data, nextLink}) {
            state.isLoading = false;
            state.currentForecaster = data.forecaster;
            state.forecasts = data.forecasts;
            state.isForecasterInfo = true;
            state.linkNextPosts = nextLink;
        },

        //Для получения избранных форкастеров
        getFavoritesStart(state) {
            state.isLoading = true;
            state.forecasts = [];
            state.currentForecaster = null;
            state.errors = [];
            state.isAllForecaster = null;
            state.linkNextPosts = '';
        },
        getFavoritesFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        getFavoritesSuccess(state, {data, nextLink}) {
            state.isLoading = false;
            state.forecasts = data.forecasts;
            state.isAllForecaster = false;
            state.isForecasterInfo = false
            state.linkNextPosts = nextLink;
        },

        // Для получения постов инфинити скрола
        getMoreForecastsStart(state) {
            state.errors = [];
        },
        getMoreForecastsFailure(state, error) {
            state.isLoading = false;
            state.errors.push(error);
        },
        getMoreForecastsSuccess(state, {data, nextLink}) {
            state.forecasts = [...state.forecasts, ...data.forecasts];
            state.linkNextPosts = nextLink;
        },
    },

    actions: {
        // Получить всех форкастеров
        async toGetForecasters({commit}) {
            commit('getForecastersStart');

            try {
                const response = await fetchWithAuth(apiEndpoints.forecasters, requestOptions.get);

                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok) {
                    throw new Error('Ошибка при загрузке данных');
                }

                const data = await response.json();

                commit('getForecastersSuccess', {mainData: data.results, nextLink: data.next});
            } catch (error) {
                commit('getForecastersFailure', error.message);
                console.error('Ошибка при загрузке форкастеров:', error);
            }
        },

        // Добавить форкастера в избранные
        async toBookForecaster({commit}, payload) {
            commit('bookForecastersStart');

            try {
                const response = await fetchWithAuth(`${apiEndpoints.forecasters}${payload.username}/`, requestOptions.post);

                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok || response.detail === 'Forecaster already in bookmarks') {
                    throw new Error('Ошибка при загрузке данных');
                }

                commit('bookForecastersSuccess');
                commit('incrementFavoritesCounter');
            } catch (error) {
                commit('bookForecastersFailure', error.message);
                console.error('Ошибка при добавлении форкастера:', error);
            }
        },

        // Удалить форкастера из избранного
        async toUnbookForecaster({commit}, payload) {
            commit('unbookForecastersStart');

            try {
                const response = await fetchWithAuth(`${apiEndpoints.forecasters}${payload.username}/`, requestOptions.delete);
                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok || response.detail === 'Forecaster already in bookmarks') {

                    throw new Error('Ошибка при загрузке данных');
                }

                commit('unbookForecastersSuccess');
                commit('decrementFavoritesCounter');
            } catch (error) {
                commit('unbookForecastersFailure', error.message);
                console.error('Ошибка при удалении форкастера:', error);
            }
        },

        // Получить одного форкастера
        async toGetForecastsOfOne({commit}, payload) {
            commit('getForecastsOfOneStart');

            try {
                const response = await fetchWithAuth(`${apiEndpoints.forecasters}${payload.username}/`, requestOptions.get);
                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok) {
                    throw new Error('Ошибка при ');
                }
                const data = await response.json();

                commit('getForecastsOfOneSuccess', {data: data.results, nextLink: data.next});
            } catch (error) {
                commit(' getForecastsOfOneFailure', error.message);
                console.error('Ошибка при :', error);
            }
        },

        // Получить избранных форкастеров
        async toGetFavorites({commit}) {
            commit('getFavoritesStart');

            try {
                const response = await fetchWithAuth(`${apiEndpoints.bookmarks}`, requestOptions.get);

                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok) {
                    throw new Error('Ошибка при ');
                }
                const data = await response.json();

                commit('getFavoritesSuccess', {data: data.results, nextLink: data.next});
            } catch (error) {
                commit(' getFavoritesFailure', error.message);
                console.error('Ошибка при :', error);
            }
        },

        // Загрузить дополнительные форкасты
        async toGetMoreForecasts({commit, state}, nextLink) {
            commit('getMoreForecastsStart');
            try {
                const response = await fetchWithAuth(nextLink);

                if (response.status === 403) {
                    commit('setAccessDenied', true);
                    return;
                } else if (!response.ok) {
                    throw new Error('Ошибка при ');
                }
                const data = await response.json();

                commit('getMoreForecastsSuccess', {data: data.results, nextLink: data.next});
            } catch (error) {
                commit('getMoreForecastsFailure', error.message);
                console.error('Ошибка при :', error);
            }
        },

        // Изменение избранных форкастеров, для отображения
        toggleBookmark({commit, state}, {id}) {
            const arr = state.mainData.sidebar?.forecasters || [];
            const index = arr.findIndex((item) => {
                return item.forecaster.id === id;
            });

            if (index !== -1) {
                const item = arr[index];

                // Новый объект с инвертированным значением is_bookmarked
                const updatedForecaster = {
                    ...item,
                    is_bookmarked: !item.is_bookmarked,
                };

                commit('updateForecasterBookmark', {index, updatedForecaster});
            } else {
                console.error(`Forecaster with id ${id} not found in the state`);
            }
        },
    },


    getters: {
        getForecasterById: (state) => (id) => {
            return state.mainData.sidebar.forecasters.find(forecaster => forecaster.forecaster.id === id);
        }
    }
};

export default ForecastersSystem;